import React, { useEffect, useState } from 'react';
import { Container, SubContainer, Image, Title, PhotosContainer, PhotosWrapper } from './styled';
import Skeleton from '@mui/material/Skeleton';
import { useDispatch, useSelector } from 'react-redux';
import { boardBackgroundUpdate } from '../../../../Services/boardService';

const FALLBACK_PHOTOS = [
	'https://images.unsplash.com/photo-1517694712202-14dd9538aa97',
	'https://images.unsplash.com/photo-1498050108023-c5249f4df085',
	'https://images.unsplash.com/photo-1504384308090-c894fdcc538d',
	'https://images.unsplash.com/photo-1497215728101-856f4ea42174',
	'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40',
	'https://images.unsplash.com/photo-1487014679447-9f8336841d58',
	'https://images.unsplash.com/photo-1484417894907-623942c8ee29',
	'https://images.unsplash.com/photo-1461749280684-dccba630e2f6',
	'https://images.unsplash.com/photo-1489515217757-5fd1be406fef',
	'https://images.unsplash.com/photo-1460925895917-afdab827c52f',
	'https://images.unsplash.com/photo-1552581234-26160f608093',
	'https://images.unsplash.com/photo-1521737604893-d14cc237f11d',
];

const getImages = async () => {
	return FALLBACK_PHOTOS.map((url, index) => ({
		id: `fallback-${index}`,
		urls: {
			small: `${url}?auto=format&fit=crop&w=420&q=60`,
			full: `${url}?auto=format&fit=crop&w=2000&q=80`,
		},
	}));
};

const DefaultMenu = (props) => {
	return (
		<Container>
			<SubContainer onClick={() => props.menuCallback('Photos by Unsplash')}>
				<Image link='https://images.unsplash.com/photo-1497215728101-856f4ea42174?auto=format&fit=crop&w=560&q=60' />
				<Title>Photos</Title>
			</SubContainer>
			<SubContainer onClick={() => props.menuCallback('Colors')}>
				<Image link='https://images.unsplash.com/photo-1460472178825-e5240623afd5?auto=format&fit=crop&w=560&q=60' />
				<Title>Colors</Title>
			</SubContainer>
		</Container>
	);
};

const PhotosMenu = (props) => {
	const [images, setImages] = useState([]);
	useEffect(() => {
		getImages().then((res) => {
			setImages(res);
		});
	}, []);

	const handleClick = (background) => {
		boardBackgroundUpdate(props.boardId, background, true, props.dispatch);
	};

	return (
		<PhotosContainer>
			{images.length > 0
				? images.map((image) => {
						return (
							<PhotosWrapper key={image.id} onClick={() => handleClick(image.urls.full)}>
								<Image key={image.id} link={image.urls.small} />
							</PhotosWrapper>
						);
				  })
				: [...Array(18).keys()].map((l, i) => (
						<PhotosWrapper key={i}>
							<Skeleton variant='rectangular' width='100%' height='6rem' />
						</PhotosWrapper>
				  ))}
		</PhotosContainer>
	);
};

const ColorsMenu = (props) => {
	const colors = ['#3B63F7', '#F76F6F', '#24A597', '#F76F6F', '#8896B3', '#F76F6F', '#2EC4B6', '#3B63F7'];

	const handleClick = (background) => {
		boardBackgroundUpdate(props.boardId, background, false, props.dispatch);
	};

	return (
		<PhotosContainer>
			{colors.map((image) => {
				return (
					<PhotosWrapper key={image} onClick={() => handleClick(image)}>
						<Image key={image} bg={image} />
					</PhotosWrapper>
				);
			})}
		</PhotosContainer>
	);
};

const BackgroundMenu = (props) => {
	const dispatch = useDispatch();
	const boardId = useSelector((state) => state.board.id);
	return (
		<>
			{props.sectionName === 'Change background' ? (
				<DefaultMenu {...props} dispatch={dispatch} boardId={boardId} />
			) : props.sectionName === 'Photos by Unsplash' ? (
				<PhotosMenu {...props} dispatch={dispatch} boardId={boardId} />
			) : (
				<ColorsMenu {...props} dispatch={dispatch} boardId={boardId} />
			)}
		</>
	);
};

export default BackgroundMenu;
